








































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import BaseView from "@/components/BaseView.vue";
import { BATCH_STATES, BatchResource } from "@/store/batch/types";
import { RequestResource, REQUESTS_STATES } from "@/store/request/types";
import TruncatedText from "@/components/TruncatedText.vue";
import { Pagination, Filter } from "@/store";
import { DataOptions } from "vuetify";
import { format } from "rut.js";

@Component({
  components: {
    BaseView,
    TruncatedText
  }
})
export default class RequestList extends Vue {
  //
  readonly store = this.$store.direct;
  readonly title = "Solicitudes";
  readonly subtitle = "Lista todas las solicitudes de firma";
  readonly info = null;
  // Component properties
  loading: boolean = false;

  get options() {
    return this.store.getters.options;
  }

  set options(val: DataOptions) {
    this.store.commit.SET_PAGINATION_FROM_DATA_OPTIONS(val);
  }

  get pagination() {
    return this.store.state.pagination;
  }

  get totalItems() {
    return this.store.state.totalItems;
  }

  get activeFilters() {
    return this.store.state.filters;
  }

  selectedFilter: {
    type: "batch" | "company" | "state" | "created_at";
    value: string;
    range: string[];
  } = {
    type: "company",
    value: "",
    range: []
  };

  get range() {
    return this.selectedFilter.range;
  }

  set range(val: string[]) {
    this.selectedFilter.range = val.sort();
  }

  get rangeText() {
    return this.selectedFilter.range.join(" ~ ");
  }

  states = [
    {
      value: "pending",
      text: "Pendiente"
    },
    {
      value: "generated",
      text: "Generada"
    },
    {
      value: "signed",
      text: "Firmada"
    }
  ];

  filters = [
    {
      value: "batch",
      text: "Carga"
    },
    {
      value: "company",
      text: "Proveedor"
    },
    {
      value: "state",
      text: "Estado"
    },
    {
      value: "created_at",
      text: "Fecha creación"
    }
  ];

  headers = [
    {
      text: "#",
      value: "attributes.id",
      sortable: false
    },
    {
      text: "Carga",
      value: "api_batches.name",
      align: "center"
    },
    {
      text: "Proveedor",
      value: "api_companies.name",
      align: "center"
    },
    {
      text: "RUT Prov.",
      value: "api_companies.rut",
      align: "center"
    },
    {
      text: "Fec. Creación",
      value: "created_at",
      align: "center"
    },
    {
      text: "Estado",
      value: "state",
      align: "center"
    },
    {
      text: "Fec. Firma",
      value: "updated_at",
      align: "center"
    },
    {
      text: "# Documentos",
      value: "forms_count",
      align: "center"
    },
    {
      text: "Acciones",
      align: "center",
      sortable: false
    }
  ];

  get requests() {
    return this.store.getters.request.requests;
  }

  get admin() {
    return this.store.getters.session.isAdmin;
  }

  getFilterText(filter: Filter) {
    let idx = this.filters.findIndex(item => {
      return item.value == filter.type;
    });
    if (idx >= 0) {
      return this.filters[idx].text;
    }
    return "";
  }

  getType(state: string) {
    let type = REQUESTS_STATES.find(t => {
      return t.value == state;
    });
    return type ? type.label : state;
  }

  getColor(state: string) {
    let type = REQUESTS_STATES.find(t => {
      return t.value == state;
    });
    return type ? type.color : "";
  }

  details(request: RequestResource) {
    this.$router.push({ path: "/requests/" + request.id });
  }

  addFilter(val: string | number | string[]) {
    this.store.commit.ADD_FILTER({
      type: this.selectedFilter.type,
      value: val
    });
    this.handleFilterTypeChange();
    this.refresh();
  }

  removeFilter(filter: Filter) {
    this.store.commit.REMOVE_FILTER(filter);
    this.handleFilterTypeChange();
    this.refresh();
  }

  formatRut(value: string) {
    return format(value);
  }

  refresh() {
    this.store.dispatch.request.get();
  }

  mounted() {
    this.refresh();
  }

  @Watch("selectedFilter.type")
  handleFilterTypeChange() {
    this.selectedFilter.value = "";
    this.selectedFilter.range = [];
  }

  @Watch("pagination", { deep: true })
  handleOptionsChange(newVal: Pagination, oldVal: Pagination) {
    if (
      this.store.state.totalItems != undefined &&
      (newVal.page != oldVal.page ||
        newVal.itemsPerPage != oldVal.itemsPerPage ||
        newVal.sortBy != oldVal.sortBy ||
        newVal.sortDesc != oldVal.sortDesc)
    ) {
      this.store.dispatch.request.get();
    }
  }
}
